import OrderflagSelector from './orderflag-selector.vue';

export default {
  install(application) {
    application.component('yx-orderflag-selector', OrderflagSelector);
  },
};
